import React from "react";
import SalesPersonList from "./SalesPersonList";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";

const SalesPerson = () => {
  return (
    <NavHeightAdjust>
      <SalesPersonList />
    </NavHeightAdjust>
  );
};

export default SalesPerson;
